// BlogRow Component (Fixed)
const BlogRow = ({ item }) => {
  const renderCategories = () => {
    // Handle both single category (string) and multiple categories (array)
    if (Array.isArray(item.categories)) {
      // Multiple categories
      return (
        <div className="flex flex-wrap gap-1">
          {item.categories.slice(0, 2).map((cat, index) => (
            <span 
              key={index} 
              className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full"
            >
              {cat}
            </span>
          ))}
          {item.categories.length > 2 && (
            <span className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full">
              +{item.categories.length - 2}
            </span>
          )}
        </div>
      );
    } else if (item.categories) {
      // Single category
      return (
        <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
          {item.categories}
        </span>
      );
    } else {
      return <span className="text-gray-400">No category</span>;
    }
  };

  return (
    <>
      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{item.title}</td>
      <td className="px-6 py-4 text-sm text-gray-500">
        {renderCategories()}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
        {item.image && (
          <img src={item.image} alt="Blog" className="h-8 w-8 rounded object-cover" />
        )}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
        <span className={`px-2 py-1 text-xs rounded-full ${
          item.featured 
            ? 'bg-green-100 text-green-800' 
            : 'bg-gray-100 text-gray-600'
        }`}>
          {item.featured ? 'Featured' : 'Not Featured'}
        </span>
      </td>
    </>
  );
};

// Parent Component Example (where you should handle "no blogs available")
const BlogsTable = ({ blogs }) => {
  if (!blogs || blogs.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500 text-lg">No blogs available</p>
        <p className="text-gray-400 text-sm mt-2">Create your first blog post to get started</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Title
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Categories
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Image
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Status
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {blogs.map((blog) => (
            <tr key={blog._id}>
              <BlogRow item={blog} />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BlogRow;